export default "__VITE_ASSET__ChV2Mhf5__"